import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import APIKit from "../../config/APIKit";

export const fetchBanners = createAsyncThunk(
  "banner/fetchBanners",
  async (storeId, { rejectWithValue }) => {
    try {
      const response = await APIKit.get(`get/banners`);
      return response.data;
    } catch (error) {
      if (error && typeof error === "object" && error.response) {
        return rejectWithValue(error.response?.data || "Banner get failed");
      }
      return rejectWithValue("Banner get failed");
    }
  }
);

const bannerSlice = createSlice({
  name: "banner",
  initialState: {
    banners: null ,
    status: "idle",
    error: null ,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.banners = action.payload.data || action.payload;
        state.error = null;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Banner get failed";
      });
  },
});

export default bannerSlice.reducer;
